// Non-text app data. Names, descriptions and download labels live in
// src/translate/<lang>/translation.json under apps.<id>.
const icon = (name) => ({
  src: require(`../assets/images/apps/${name}@128.webp`),
  src2x: require(`../assets/images/apps/${name}@256.webp`),
});

// status: 'active' — links to its page on this site; 'dev', 'archived', 'future' — icon only, no link
export const apps = [
  {
    id: 'pt',
    status: 'active',
    icon: icon('pt'),
    downloadsCount: '19 000 000+',
    ratingsCount: '423 000+',
    ratingsTotal: 423000,
    rating: '4.8',
    page: '/pt-mobile',
    ogImage: '/og/pt',
    appStore: 'https://apps.apple.com/app/id1451726577',
    googlePlay: 'https://play.google.com/store/apps/details?id=mendeleev.redlime',
  },
  {
    id: 'physics',
    status: 'active',
    icon: icon('physics'),
    downloadsCount: '920 000+',
    ratingsCount: '9 000+',
    ratingsTotal: 9000,
    rating: '4.8',
    page: '/physics',
    ogImage: '/og/physics',
    appStore: 'https://apps.apple.com/app/id1495587959',
    googlePlay: 'https://play.google.com/store/apps/details?id=august.fizika',
  },
  {id: 'matem', status: 'dev', icon: icon('matem')},
  {id: 'tvorog', status: 'dev', icon: icon('tvorog')},
  {id: 'gallium', status: 'archived', icon: icon('gallium')},
  {id: 'esenin', status: 'archived', icon: icon('esenin')},
  {id: 'universe-say', status: 'archived', icon: icon('universe-say')},
  {
    id: 'future',
    status: 'future',
    icon: {
      src: require('../assets/images/apps/future.svg').default,
      src2x: require('../assets/images/apps/future.svg').default,
    },
  },
];
